import { render, staticRenderFns } from "./ActivateComplete.vue?vue&type=template&id=3055a72a&scoped=true&lang=pug&"
import script from "./ActivateComplete.vue?vue&type=script&lang=ts&"
export * from "./ActivateComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3055a72a",
  null
  
)

export default component.exports